import React from "react";
import { ListGroup, Button } from "react-bootstrap";
import {
  FaClipboard,
  FaFileAlt,
  FaArrowUp
} from "react-icons/fa";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import { formatPrice, titleCase } from "../../utils/index";
import Moment from "react-moment";
import "./../products/show.css";
import { toast } from "react-toastify";
import { CopyToClipboard } from "react-copy-to-clipboard";

const MoqCardItem = ({ moq, toggleModal, privilege }) => {
  const firstImage = moq.product[0].images && moq.product[0].images.length > 0 ? moq.product[0].images[0] : null;

    // Example usage for MOQ Price
    const displayPrice = formatPrice(moq.price, moq.moq_attributes, "price");

    // Example usage for Below MOQ Price
    const displayBelowMOQPrice = formatPrice(moq.below_moq_price, moq.moq_attributes, "below_moq_price");

    // Example usage for Supplier Price
    // Use supplier currency if defined, fallback to "KES"
    const supplierCurrency = moq.supplier_currency ?? "KES";
    const displaySupplierPrice = formatPrice(
        moq.readable_supplier_price ?? moq.supplier_price,
        moq.moq_attributes,
        "supplier_price",
        supplierCurrency
    );

    let displayTargetMOQ = moq.quantity
    let displayMinimumMOQPP = moq.min_quantity
    let displayTotalOrders = moq.total_bid_quantity
    let totalPaidOrders = moq.paid_bid_quantity
    let ordersRemainingMOQ = moq.moq_bid_balance

    const numericPaidAmount = parseFloat(moq.paid_bid_amount)
    let totalPaidAmount
    if (!isNaN(numericPaidAmount)) {
            totalPaidAmount = `KES ${numericPaidAmount.toLocaleString('en-KE')}`;
        } else {
            totalPaidAmount = `KES ${numericPaidAmount}`;
        }

  return (
    <div
      style={{
        marginBottom: "15px",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        backgroundColor: "#fff",
        overflow: "hidden",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
      }}
    >
      {/* Header */}
  <div className="moq-header-container">
  {firstImage && (
    <LazyLoadImage
      src={firstImage}
      alt={moq.product[0].name}
      className="moq-header-image"
    />
  )}

  <div className="moq-header-text">
    <h6 className="moq-title">
      <Link to={`/admin/products/${moq.product[0].id}`}>
        {titleCase(moq.product[0].name)}
      </Link>{" "}
      - MOQ no. {moq.moq_number} ({moq.status === 1 ? "Active" : "Inactive"})
      {moq.moq_order_status !== "not placed" &&
        moq.order.length > 0 && (
          <>
            -{" "}
            <Link to={`/admin/orders/${moq.order[0].id}`}>
              Order #{moq.order[0].order_number}
            </Link>
          </>
        )}
    </h6>

    <h6 className={`moq-status sort-${moq.sort_order}`}>
      {moq.moq_order_status}
    </h6>
  </div>

  {/* Round status button to the far right */}
  <span className={`status-button ${moq.status === 1 ? 'active' : 'inactive'}`}></span>

  <style jsx>{`
    .moq-header-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between; /* ✅ Make button float right */
      padding: 1em;
      background-color: #f7f7f7;
      border-bottom: 1px solid #e0e0e0;
      gap: 1em;
    }

    .moq-header-image {
      height: 100px;
      width: 100px;
      object-fit: contain;
      border: 1px solid #ccc;
      border-radius: 6px;
      background: #fff;
      padding: 4px;
      flex-shrink: 0;
    }

    .moq-header-text {
      display: flex;
      flex-direction: column;
      gap: 0.25em;
      flex: 1 1 auto;
    }

    .moq-title {
      font-size: 16px;
      font-weight: normal;
      margin: 0;
    }

    .moq-title a {
      color: #111;
      text-decoration: none;
    }

    .moq-status {
      padding: 2px 10px;
      border-radius: 20px;
      font-size: 12px;
      border: 1px solid #757575;
      white-space: nowrap;
      width: fit-content;
    }

    .moq-status.sort-1 { background-color: #ef4444; color: #000; border-color: #ef4444; }
    .moq-status.sort-2 { background-color: #009e42ff; color: #fff; border-color: #009e42ff; }
    .moq-status.sort-3 { background-color: #f59e0b; color: #fff; border-color: #f59e0b; }

    /* Round button to the right */
    .status-button {
      height: 20px;
      width: 20px;
      border-radius: 50%;
      border: 2px solid #fff;
      flex-shrink: 0;
    }
    .status-button.active { background-color: #22c55e; } /* green */
    .status-button.inactive { background-color: #ef4444; } /* red */

    /* Mobile adjustments */
    @media (max-width: 600px) {
      .moq-header-container {
        flex-direction: row;
        align-items: center;
        gap: 0.5em;
        padding: 0.75em;
      }

      .moq-title { font-size: 14px; }
      .moq-status { font-size: 11px; padding: 2px 8px; }
      .status-button { height: 16px; width: 16px; }
    }
  `}</style>
  </div>

      {/* Body */}
      <div style={{ padding: "5px" }}>
        <ListGroup variant="flush">
            <ListGroup.Item>
                <h6 className="moq-date" style={{ textAlign: "left", fontSize: "16px" }}>
                    Created <Moment format="LL">{moq.start_date}</Moment>
                    {moq.order.length > 0 && moq.moq_order_status !== "not placed" && (
                    <>
                        {" "}
                        to <Moment format="LL">{moq.order[0].date_created}</Moment>
                    </>
                    )}
                </h6>

                <h6 className="moq-source" style={{ textAlign: "left", fontSize: "16px" }}>
                    {privilege === 2 && (
                    <a href={moq.source} target="_blank" rel="noopener noreferrer">
                        Source link
                    </a>
                    )}
                </h6>

                {/* Styled summary card */}
                <div className="moq-summary-card">
                  <div className="row"><strong>MOQ Price:</strong><span>{displayPrice}</span></div>
                  <div className="row"><strong>Below MOQ Price:</strong><span>{displayBelowMOQPrice}</span></div>
                  <div className="row"><strong>Supplier Price:</strong><span>{displaySupplierPrice}</span></div>
                  <div className="row"><strong>Minimum MOQ PP:</strong><span>{displayMinimumMOQPP}</span></div>
                  <div className="row"><strong>Target MOQ Quantity:</strong><span>{displayTargetMOQ}</span></div>
                  <div className="row"><strong>Total Orders:</strong><span>{displayTotalOrders}</span></div>
                  <div className="row"><strong>Orders Remaining MOQ:</strong><span>{ordersRemainingMOQ}</span></div>
                  <div className="row"><strong>Total Paid Orders:</strong><span>{totalPaidOrders}</span></div>
                  <div className="row"><strong>Total Collected:</strong><span>{totalPaidAmount}</span></div>
                </div>

                <style jsx>{`
                .moq-summary-card {
                  display: grid;
                  grid-template-columns: repeat(2, 1fr); /* 2 columns */
                  gap: 8px 20px;                         /* vertical + horizontal spacing */
                  margin-top: 0;
                  font-size: 15px;
                  line-height: 1.6;
                  text-align: left;
                }

                .moq-summary-card .row {
                  display: flex;
                  justify-content: space-between; /* label left, value right */
                  align-items: center;
                  flex-wrap: nowrap;              /* prevent wrapping */
                  white-space: nowrap;            /* keep everything on one line */
                  overflow: hidden;
                  text-overflow: ellipsis;
                  border-radius: 6px;
                  background-color: transparent;
                  grid-column: span 1;            /* each row occupies one grid cell */
                }

                .moq-summary-card .row strong {
                  flex: 0 1 auto;                 /* label takes needed space */
                  margin-right: 8px;
                  font-weight: 600;
                  color: #333;
                }

                .moq-summary-card .row span {
                  flex: 0 0 auto;
                  max-width: 200px;
                  text-align: right;
                  color: #111;
                  font-weight: 500;
                }

                /* Mobile layout: single column for smaller screens */
                @media (max-width: 600px) {
                  .moq-summary-card {
                    grid-template-columns: 1fr;   /* single column on mobile */
                    gap: 6px;
                    font-size: 12px;
                  }

                  .moq-summary-card .row {
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: nowrap;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }

                  .moq-summary-card .row strong {
                    flex: 1;
                    margin-right: 8px;
                  }

                  .moq-summary-card .row span {
                    flex: 0;
                    text-align: right;
                  }
                }
                `}</style>

                </ListGroup.Item>


            <ListGroup.Item>
            <div
                style={{ flex: 1, minWidth: "140px" }}
                className="d-flex flex-wrap gap-2 align-items-center mt-3">
                <Button
                as={Link}
                to={`/admin/moqs/${moq.id}`}
                variant="warning"
                size="sm"
                >
                <FaFileAlt className="me-1" />
                View MOQ
                </Button>

                {(moq.moq_order_status === "not placed" && moq.paid_bid_quantity > 0) && (
                <Button
                variant="success"
                size="sm"
                onClick={() => {
                    toggleModal(moq.id);
                }}
                >
                <FaArrowUp className="me-1" />
                Raise PO
                </Button>
                )}

                <CopyToClipboard
                text={moq.moq_text}
                onCopy={() => {
                    toast.success("MOQ Text Copied!", {
                    position: "bottom-center",
                    });
                }}
                >
                <Button variant="primary" size="sm">
                    <FaClipboard className="me-1" />
                    Share Update
                </Button>
                </CopyToClipboard>
            </div>
            </ListGroup.Item>
        </ListGroup>
      </div>
    </div>
  );
};

export default MoqCardItem;
